// constants/storageKeys.ts

export const STORAGE_KEYS = {
  SELECTED_VACANCY_ID: "selectedVacancyId",
  DUPLICATE_VACANCY_ID: "duplicateVacancyId",

  SELECTED_CENTRE_ID: "selectedCentreId",
  SELECTED_CENTRE_UUID: "selectedCentreUuid",

  // Impersonation feature keys
  IMPERSONATION_DATA: "impersonation",
};
